/**
 * Standards + criteria API client (plan 18.2, section's route table verbatim).
 *
 * A new module, not an addition to services/api.js (P4's file list: that module belongs to
 * a different phase). Imports the shared axios instance from './api' so every request still
 * carries the bearer-token and 401 interceptors already wired up there.
 *
 * Trimmed against the main app's client/src/services/api.js standardsAPI: no linkage
 * endpoints, no extractFromPdf, no clone/summary/getSummary - 18.2's table lists none of
 * those for this demo ("No linkage endpoints, no PDF extraction, no requirementsAPI stub").
 */
import api from './api';

export const standardsAPI = {
  getAll: (params) => api.get('/api/v1/standards/', { params }),
  getById: (id) => api.get(`/api/v1/standards/${id}`),
  create: (data) => api.post('/api/v1/standards/', data),
  update: (id, data) => api.put(`/api/v1/standards/${id}`, data),
  delete: (id) => api.delete(`/api/v1/standards/${id}`),
  addRequirement: (standardId, data) =>
    api.post(`/api/v1/standards/${standardId}/requirements`, data),
  updateRequirement: (standardId, requirementId, data) =>
    api.patch(`/api/v1/standards/${standardId}/requirements/${requirementId}`, data),
  deleteRequirement: (standardId, requirementId) =>
    api.delete(`/api/v1/standards/${standardId}/requirements/${requirementId}`),
  // linkage_mode is always "manual" from ImportStandardPage (18.3); the field still travels
  // on the request body because 18.2's StandardImport schema requires it.
  import: (data) => api.post('/api/v1/standards/import', data),
};

// Thin, read-only views over the GRIHA standard for the review UI (18.2: "kept from
// section 7 as thin views ... GRIHA-C04 ids"). GET /criteria requires ADMIN per 19.4.
export const criteriaAPI = {
  getAll: () => api.get('/api/v1/criteria'),
  getById: (id) => api.get(`/api/v1/criteria/${id}`),
};
